import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Card, Container, Row, Col } from "react-bootstrap";
import config from "../../config";
import Layout from "../../components/layouts/Main";

const PlantView = () => {
    const { id } = useParams();
    const [plant, setPlant] = useState(null);

    useEffect(() => {
        axios.get(`${config.API_BASE_URL}/plants/${id}`).then(res => setPlant(res.data));
    }, [id]);

    if (!plant) return <div>Loading...</div>;

    return (
        <Layout>
            {/* Breadcrumb */}
            <nav aria-label="breadcrumb" className="mb-3">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
                    <li className="breadcrumb-item"><Link to="/plants">Plants</Link></li>
                    <li className="breadcrumb-item active">{plant.name}</li>
                </ol>
            </nav>

            {/* Bill Of Materials (BOM) Header */}
            <Row className="gy-3">
                <Col className="col"><h2>{plant.name}</h2></Col>
                <Col className="text-end col-auto">
                    <div className="d-flex justify-content-end flex-wrap gap-2">
                        
                    </div>
                </Col>
            </Row>
            <Container fluid className="my-4">
                <Card>
                    <Card.Body>
                        <h5>Plant Name: {plant.name}</h5>
                        <hr />
                        <h6 className="text-muted mb-3">Plant Location: {plant.location}</h6>
                        
                    </Card.Body>
                </Card>
            </Container>
        </Layout>
    );
};

export default PlantView;
